import React from "react";
import clsx from "clsx";
import Tab from "@mui/material/Tab";

import * as NavigationUtils from "../../../../lib/util/NavigationUtils";
import * as AnalyticsUtils from "../../../../lib/util/AnalyticsUtils";

import Text from "../../../common/Text/Text";
import Tooltip from "../../../common/Tooltip/Tooltip";

export default class MenuBarTab extends React.PureComponent {
	static contextType = AnalyticsUtils.TrackingContext;
	ref = React.createRef();
	state = { hovered: false };

	handleMouseEnter = () => {
		const { item } = this.props;

		if (item.tooltipProps && item.tooltipProps.open !== false) {
			this.setState({ hovered: true }, () => {
				AnalyticsUtils.sendEvent({
					eventCategory: "Menu Bar Tab",
					eventLabel: this.context.ga || this.context,
					eventAction: "hover",
					mixpanelProperties: {
						name: "Menu Tab Toolip Open",
						Item: item.id,
						...(this.context.mixpanel || { Context: this.context }),
					},
				});
			});
		}
	};

	handleMouseLeave = () => {
		const { item } = this.props;

		if (item.tooltipProps) {
			this.setState({ hovered: false });
		}
	};

	componentDidMount() {
		const route = NavigationUtils.getRouteForPath(this.props.href);
		if (route) {
			NavigationUtils.preload(route);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.href !== this.props.href) {
			this.componentDidMount();
		}
	}

	render() {
		const {
			item,
			onFilterItem,
			onRenderItem,
			selected,
			onClick,
			onActivated,
			children,
			value,
			disabled,
			loading,
			...props
		} = this.props;

		if (item.id === undefined) {
			throw new Error(
				`All nav items must have an ID, link '${item.displayName}' does not`,
			);
		}
		// Abort early if it doesn't match the filter condition
		if (onFilterItem && !onFilterItem(item)) {
			return <div className={"Tab__stub"} />;
		}

		let content = <Text>{item.displayName}</Text>;
		if (onRenderItem) {
			content = onRenderItem(item, content);
		}

		return (
			<Tab
				{...props}
				disableRipple={true}
				disabled={loading || disabled}
				id={item.id || this.key}
				value={value}
				classes={{
					root: clsx("MenuBar__tab", selected && "--selected", {
						"--skeleton": loading,
					}),
				}}
				onMouseEnter={this.handleMouseEnter}
				href={item.pathName}
				onMouseLeave={this.handleMouseLeave}
				label={
					<>
						{item.tooltipProps ? (
							<Tooltip
								overflow={true}
								tooltipClassName={"InfoTooltip"}
								visible={this.state.hovered}
								{...item.tooltipProps}
							>
								{content}
							</Tooltip>
						) : (
							content
						)}
						{children}
					</>
				}
			/>
		);
	}
}
